import * as React from 'react';
import './style.css';

class SlideShow extends React.Component<{}, {}> {
  
  render() {
    return (
      <div className="slideShow">
        <ul className="cbSlideshow">
          <li><span/></li>
          <li><span/></li>
          <li><span/></li>
          <li><span/></li>
          <li><span/></li>
          <li><span/></li>
        </ul>
      </div>
    );
  }
}

export default SlideShow;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Scenes/HomePage/Components/Header/Components/SlideShow/index.tsx